import { defineAsyncComponent } from 'vue';
const ConfirmDialog = defineAsyncComponent(() =>
  import('@/components/dialog_popup/ConfirmDialog.vue')
);

const PromptDialog = defineAsyncComponent(() =>
  import('@/components/dialog_popup/PromptDialog.vue')
);

const ResetPassword = defineAsyncComponent(() =>
  import('@/components/dialog_popup/ResetPassword.vue')
);

const Register = defineAsyncComponent(() =>
  import('@/components/dialog_popup/Register.vue')
);

const Update = defineAsyncComponent(() =>
  import('@/components/dialog_popup/Update.vue')
);

const HistoryPanel = defineAsyncComponent(() =>
  import('@/components/common/HistoryPanel.vue')
);

const UpdateAccount = defineAsyncComponent(() =>
  import('@/pages/UpdateAccount.vue')
);

const UpdatePartner = defineAsyncComponent(() =>
  import('@/pages/PartnerDetail.vue')
);

const RequestDiscount = defineAsyncComponent(() =>
  import('@/components/dialog_popup/RequestDiscount.vue')
);

const RequestLicenseInfo = defineAsyncComponent(() =>
  import('@/components/dialog_popup/LicenseInfo.vue')
);

export function registerCommonPopup(app) {
  app.component('ConfirmDialog', ConfirmDialog);
  app.component('PromptDialog', PromptDialog);
  app.component('ResetPassword', ResetPassword);
  app.component('Register', Register);
  app.component('Update', Update);
  app.component('HistoryPanel', HistoryPanel);
  app.component('UpdateAccount', UpdateAccount);
  app.component('UpdatePartner', UpdatePartner);
  app.component('RequestDiscount', RequestDiscount);
  app.component('RequestLicenseInfo', RequestLicenseInfo);

}
